"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _Component = _interopRequireDefault(require("../../Component"));

var _style = _interopRequireDefault(require("../style"));

var _react = _interopRequireDefault(require("react"));

var _menu = _interopRequireDefault(require("../menu.c"));

var _documentOffset = _interopRequireDefault(require("document-offset"));

var _variables = require("../variables");

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

var _userAgent = _interopRequireDefault(require("../../../common/userAgent.0.0.3"));

var _reactEventListener = _interopRequireDefault(require("react-event-listener"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var hasHover = !_userAgent["default"].browser.isMobileDevice,
    Wrapper = _createStyled["default"].div(_templateObject()),
    SubMenu = _createStyled["default"].div(_templateObject2()),
    Item = _createStyled["default"].div(_templateObject3());

var MenuItem =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(MenuItem, _View);

  function MenuItem(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuItem);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuItem).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleMouseEnter",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.hover = true;
              clearTimeout(_this.sharpAngleTimemout);
              _this.docH = window.document.body.offsetHeight;
              _this.docW = window.document.body.offsetWidth;

              if (_this._isSharpAngle()) {
                _context2.next = 10;
                break;
              }

              _context2.next = 7;
              return _this.setState({
                active: true
              });

            case 7:
              _this.setState({
                position: _this.getPosition()
              });

              _context2.next = 11;
              break;

            case 10:
              _this.sharpAngleTimemout = setTimeout(
              /*#__PURE__*/
              (0, _asyncToGenerator2["default"])(
              /*#__PURE__*/
              _regenerator["default"].mark(function _callee() {
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!_this.hover) {
                          _context.next = 4;
                          break;
                        }

                        _context.next = 3;
                        return _this.setState({
                          active: true
                        });

                      case 3:
                        _this.setState({
                          position: _this.getPosition()
                        });

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })), 150);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleMouseLeave", function () {
      clearTimeout(_this.sharpAngleTimemout);
      _this.hover = false;

      if (_this._isSharpAngle()) {
        _this.sharpAngleTimemout = setTimeout(function () {
          _this.setState({
            active: false
          });
        }, 150);
      } else {
        _this.setState({
          active: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleMouseClick", function () {
      _this.setState({
        active: !_this.state.active
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleMouseMove", function (event) {
      _this.mouseEvents.unshift({
        x: event.pageX,
        y: event.pageY
      });

      if (_this.mouseEvents.length > 10) {
        _this.mouseEvents.length = 10;
      }
    });
    _this.state = {
      active: false,
      position: "".concat(_variables.X_POSITION_RIGHT, "-").concat(_variables.Y_POSITION_TOP)
    };
    _this.mouseEvents = [];
    _this.root = _react["default"].createRef();
    _this.subMenu = _react["default"].createRef();
    _this.hover = false;
    return _this;
  }

  (0, _createClass2["default"])(MenuItem, [{
    key: "render",
    value: function render() {
      var styles = this.compileStyled(_style["default"]),
          _this$state = this.state,
          active = _this$state.active,
          position = _this$state.position,
          children = _react["default"].Children.toArray(this.props.children),
          items = [];

      var subMenu;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.type === _menu["default"]) {
            subMenu = item; // take it from props on Menu components
            // because of this props are not logical part of MenuItem component

            this.rightTop = item.props.rightTop;
            this.rightBottom = item.props.rightBottom;
            this.leftTop = item.props.leftTop;
            this.leftBottom = item.props.leftBottom;
          } else {
            items.push(item);
          }
        } // default position

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!this.rightTop && !this.rightBottom && !this.leftTop && !this.leftBottom) {
        this.rightTop = true;
      }

      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_reactEventListener["default"], {
        target: window,
        onMouseMove: this._handleMouseMove
      }), _react["default"].createElement(Wrapper, {
        styles: styles.itemWrapper,
        onMouseEnter: subMenu && hasHover ? this._handleMouseEnter : null,
        onMouseLeave: subMenu && hasHover ? this._handleMouseLeave : null,
        onClick: subMenu && !hasHover ? this._handleMouseClick : null,
        ref: this.root
      }, active ? _react["default"].createElement(SubMenu, {
        styles: styles[position],
        ref: this.subMenu
      }, subMenu) : null, _react["default"].createElement(Item, (0, _extends2["default"])({}, this.props, {
        theme: null,
        styles: styles.item
      }), items)));
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      var elWidth = this.root.current.offsetWidth,
          elHeight = this.root.current.offsetHeight,
          offset = (0, _documentOffset["default"])(this.root.current),
          subMenuWidth = this.subMenu.current.offsetWidth,
          subMenuHeight = this.subMenu.current.offsetHeight;
      var bottomAvailable = true,
          topAvailable = true,
          leftAvailable = true,
          rightAvailable = true,
          xPosition = _variables.X_POSITION_RIGHT,
          yPosition = _variables.Y_POSITION_TOP;

      if (offset) {
        // нет места снизу
        if (offset.top + subMenuHeight > this.docH) {
          bottomAvailable = false;
        } // нет места сверху


        if (offset.top + elHeight - subMenuHeight <= 0) {
          topAvailable = false;
        } // нет места справа


        if (offset.left + elWidth + subMenuWidth > this.docW) {
          rightAvailable = false;
        } // нет места слева


        if (offset.left - (elWidth + subMenuWidth) <= 0) {
          leftAvailable = false;
        }
      }

      if (this.rightTop) {
        xPosition = rightAvailable ? _variables.X_POSITION_RIGHT : leftAvailable ? _variables.X_POSITION_LEFT : _variables.X_POSITION_RIGHT;
        yPosition = bottomAvailable ? _variables.Y_POSITION_TOP : topAvailable ? _variables.Y_POSITION_BOTTOM : _variables.Y_POSITION_TOP;
      } else if (this.rightBottom) {
        xPosition = rightAvailable ? _variables.X_POSITION_RIGHT : leftAvailable ? _variables.X_POSITION_LEFT : _variables.X_POSITION_RIGHT;
        yPosition = topAvailable ? _variables.Y_POSITION_BOTTOM : _variables.Y_POSITION_TOP;
      } else if (this.leftTop) {
        xPosition = leftAvailable ? _variables.X_POSITION_LEFT : _variables.X_POSITION_RIGHT;
        yPosition = bottomAvailable ? _variables.Y_POSITION_TOP : topAvailable ? _variables.Y_POSITION_BOTTOM : _variables.Y_POSITION_TOP;
      } else if (this.leftBottom) {
        xPosition = leftAvailable ? _variables.X_POSITION_LEFT : _variables.X_POSITION_RIGHT;
        yPosition = topAvailable ? _variables.Y_POSITION_BOTTOM : _variables.Y_POSITION_TOP;
      }

      return "".concat(xPosition, "-").concat(yPosition);
    }
  }, {
    key: "_isSharpAngle",
    value: function _isSharpAngle() {
      var _this$mouseEvents;

      var poll = (_this$mouseEvents = this.mouseEvents) === null || _this$mouseEvents === void 0 ? void 0 : _this$mouseEvents.slice(0, 10);
      var result = false;

      if (poll && poll.length >= 2) {
        var p1 = poll[0],
            p2 = poll[poll.length - 1],
            angle = Math.abs(Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI);
        result = angle >= 25 && angle <= 65 || angle >= 115 && angle <= 165;
      }

      return result;
    }
  }]);
  return MenuItem;
}(_Component["default"]);

(0, _defineProperty2["default"])(MenuItem, "displayName", 'MenuItem');
var _default = MenuItem;
exports["default"] = _default;